<template>
    <header id="Header" class="flex-between-center bg-light mb-3 px-4">
      <!-- Left side: menu + welcome -->
      <div class="flex-center">
        <button
          @click.stop="hideMenu"
          class="btn btn-light me-2 p-2"
          aria-label="Toggle menu"
        >
          <img :src="menu" alt="Menu" />
        </button>
        <div class="d-none d-sm-block">
          <span class="description-sm poppins-semibold text-black pe-5 text-capitalize">
            Welcome {{ user_data.first_name }} {{ user_data.last_name }}
          </span>
        </div>
      </div>
  
      <!-- Right side: search + bell + profile -->
      <div class="flex-center">
        <div class="position-relative me-3">
          <input
            @input="e => store.commit('setSearch', e.target.value)"
            v-model="local_search"
            class="form-control description-xs px-4 py-2 mb-3 mb-sm-0 rounded-20 border-0"
            placeholder="Search"
            type="text"
            style="min-width: 334px; max-width: 334px; width: 100%;"
          />
          <img
            class="position-absolute"
            style="width: 24px; right: 10px; top: 8px;"
            :src="icon_search"
            alt="Search icon"
          />
        </div>
  
        <!-- Notification bell -->
        <button
          class="btn btn-light me-2 p-2 position-relative"
          @click.stop="handleBellClick"
          :disabled="notificationCount === 0"
          aria-label="View notifications"
        >
          <img :src="bell" alt="Notifications" />
          <span v-if="notificationCount > 0" class="notification-badge">
            {{ notificationCount }}
          </span>
        </button>
  
        <!-- Profile icon -->
        <button
          class="btn btn-light p-2"
          @click="goToProfile"
          aria-label="My profile"
        >
          <img :src="user" alt="User profile" />
        </button>
      </div>
    </header>
  </template>
  
  <script setup>
  import { ref, computed, watch } from 'vue'
  import { useStore } from 'vuex'
  import { useRouter } from 'vue-router'
  import icon_search from '@/assets/icons/search.svg'
  
  // Your webpack alias for icons (adjust if needed)
  const menu = require('ASSETS/icons/header/menu')
  const bell = require('ASSETS/icons/header/bell')
  const user = require('ASSETS/icons/header/user')
  
  const store = useStore()
  const router = useRouter()
  const emit = defineEmits(['hide', 'open-notifications'])
  
  // User info from Vuex
  const user_data = computed(() => store.getters.getUser)
  
  // Search sync
  const local_search = ref(store.getters.getSearch)
  watch(() => store.getters.getSearch, v => {
    local_search.value = v
  })
  
  // Notifications from Vuex
  const notifications = computed(() => store.getters['notifications/getAll'] || [])
  const notificationCount = computed(() => notifications.value.length)
  
  function hideMenu() {
    emit('hide')
  }
  
  function handleBellClick() {
    if (notificationCount.value > 0) {
      emit('open-notifications')
    }
  }
  
  function goToProfile() {
    // Navigate by path to avoid name mismatches
    router.push('/profile')
  }
  </script>
  
  <style lang="scss" scoped>
  #Header {
    background-color: #FFFAF1;
    border-radius: 24px;
    height: 82px;
    width: 100%;
  }
  
  .btn-light {
    background: #e0e0e0;
    border: none;
    border-radius: 8px;
  }
  
  .btn-light:focus {
    outline: 2px solid #007BFF;
  }
  
  .notification-badge {
    position: absolute;
    top: 4px;
    right: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    font-size: 10px;
    font-weight: bold;
    color: white;
    background-color: #e02424;
    border-radius: 50%;
    line-height: 1;
  }
  </style>
  